import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      item: item.href ? `http://chigualiao.cn/${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 py-3">
        {items.map((item, idx) => (
          <span key={idx} className="flex items-center gap-1.5">
            {idx > 0 && <i className="ri-arrow-right-s-line text-[10px]"></i>}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-400">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}